import { RouteConfig } from 'src/routing/types'

const ROUTE: RouteConfig = {
  name: 'discrimination-policy',
  path: () => '/discrimination-policy',
}

export default ROUTE
